module.exports = __webpack_public_path__ + "static/img/bg14.4f79d99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg14.png
// module id = xY3Z
// module chunks = 1